<div 	class="promotion"
		[ngStyle]="{ 'color': fol && '#fdd329' }">
	<div class="title" *ngIf="merchantService.merchant?.promotion?.title">{{ merchantService.merchant.promotion.title }}</div>
	<div class="description font-dosis" *ngIf="merchantService.merchant?.promotion?.description">{{ merchantService.merchant.promotion.description }}</div>
</div>